import About from "./About";
import Connect from "./Connect";
import Experience from "./Experience";
import Footer from "./Footer";
import Home from "./Home";
import Projects from "./Projects";
import Skills from "./Skills";

function Main() {
  return (
    <div className="text-3xl font-bold mx-auto max-w-5xl my-6 sm:my-8 md:my-10 overflow-x-hidden">
      <Home />
      <About />
      <Experience />
      <Skills />
      <Projects />
      <Connect />
      <Footer />
    </div>
  );
}

export default Main;
